import { createSelector } from 'reselect';

export const selectProducts = (state) => state.products.products;

export const findProdById = (id) => state => {
    if (id) {
        let results;
        if (id.includes('-')) {
            console.log('anel com tamanho ')

            const idProd = id.split('-')[0]
            const tamanhoProd = id.split('-')[1]
            results = []
            const prods = state.products.products
            for (const key in prods) {
                const product = prods[key]
                const findItem = product?.find((data) => data.id_produto.toString() === idProd.toString() && Number(data.tamanho) === Number(tamanhoProd))
                if (findItem) {
                    results.push(findItem)
                }
            }
        } else {
            results = []
            const prods = state.products.products
            for (const key in prods) {
                const product = prods[key]
                const findItem = product?.find((data) => data.id_produto.toString() === id.toString())
                if (findItem) {
                    results.push(findItem)
                }
            }
        }
        return results
    }
    return
}

export const findProdByIdAndPk = (id) => state => {
    if (id) {
        let results;
        if (id.includes('-')) {
            console.log('anel com tamanho ')
            results = []
            const prods = state.products.products
            for (const key in prods) {
                const product = prods[key]
                const findItem = product?.find((data) => {
                    const newIdToFind = `${data.id_produto}-${data.pk}`
                    return id.toString() === newIdToFind.toString()
                })
                // const findItem = product?.find((data) => data.id_produto.toString() === idProd.toString() && Number(data.tamanho) === Number(tamanhoProd))
                if (findItem) {
                    results.push(findItem)
                }
            }
        } else {
            results = []
            const prods = state.products.products
            for (const key in prods) {
                const product = prods[key]
                const findItem = product?.find((data) => data.id_produto.toString() === id.toString())
                if (findItem) {
                    results.push(findItem)
                }
            }
        }
        return results
    }
    return
}

export const findProdByIdMultiplo = (id) => state => {
    if (id) {
        let results;
        if (id.includes('-')) {
            console.log('anel com tamanho ')

            const idProd = id.split('-')[0]
            const tamanhoProd = id.split('-')[1]
            results = []
            const prods = state.products.products
            for (const key in prods) {
                const product = prods[key]
                const findItem = product?.filter((data) => data.id_produto.toString() === idProd.toString() && Number(data.tamanho) === Number(tamanhoProd))
                if (findItem) {
                    results.push(findItem)
                }
            }
        } else {
            results = []
            const prods = state.products.products
            for (const key in prods) {
                const product = prods[key]
                const findItem = product?.filter((data) => data.id_produto.toString() === id.toString())
                if (findItem) {
                    results.push(findItem)
                }
            }
        }
        return results.filter(filteredArray => filteredArray.length > 0).flat();
    }
    return
}

export const selectKitPending = (state) => state.products.kitPending;


export const getKitsBySeller = (sellerId) => state => {
    return state.products.sellersKits.find((data) => data.user.id === sellerId)
}

const selectAllProducts = (state) => state?.products?.products || {};

export const getProductsByModel = (modelName) =>
    createSelector([selectAllProducts], (allProducts) => {
        if (modelName === 'Todos') {
            return Object.values(allProducts).flat();
        }

        return allProducts[modelName] || [];
    });